import { RouteConfig } from 'vue-router';
const paymentRoute = [
	{
		path: '/paiements/exp',
		name: 'paymentsExp',
		component: () => import(
			/* webpackChunkName: "paymentList" */
			'../../views/Payments.vue'
			),
		props: {
			default: true,
			type: 'payment-exp'
		}
	},
	{
		path: '/paiements/exp/administration',
		name: 'paymentListExpAdministration',
		component: () => import(
			/* webpackChunkName: "payment_list_administration" */
			'../../components/payment/list/PaymentListAdministration.vue'
			),
		props: {
			default: true,
			type: 'payment-exp'
		},
		meta: {
			label: 'router.label.payments',
			subLabel: 'router.subLabel.administration',
			can: 'payments_administration_exp',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/exp/validation',
		name: 'paymentListExpValidation',
		component: () => import(
			/* webpackChunkName: "payment_list_validation" */
			'../../components/payment/list/PaymentListValidation.vue'
		),
		props: {
			default: true,
			type: 'payment-exp'
		},
		meta: {
			label: 'router.label.payments',
			subLabel: 'router.subLabel.validation',
			can: 'payments_validation_exp',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/exp/liquidation',
		name: 'paymentListExpLiquidation',
		component: () => import(
			/* webpackChunkName: "payment_list_liquidation" */
			'../../components/payment/list/PaymentListLiquidation.vue'
		),
		props: {
			default: true,
			type: 'payment-exp'
		},
		meta: {
			label: 'router.label.payments',
			subLabel: 'router.subLabel.liquidation',
			can: 'payments_liquidation_exp',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/exp/supervision',
		name: 'paymentListExpSupervision',
		component: () => import(
			/* webpackChunkName: "payment_list_supervision" */
			'../../components/payment/list/PaymentListSupervision.vue'
		),
		props: {
			default: true,
			type: 'payment-exp'
		},
		meta: {
			label: 'router.label.payments',
			subLabel: 'router.subLabel.supervision',
			can: 'payments_supervision_exp',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/pcr',
		name: 'paymentsPcr',
		component: () => import(
			/* webpackChunkName: "paymentList" */
			'../../views/Payments.vue'
			),
		props: {
			default: true,
			type: 'payment-pcr'
		}
	},
	{
		path: '/paiements/pcr/administration',
		name: 'paymentListPcrAdministration',
		component: () => import(
			/* webpackChunkName: "payment_list_administration" */
			'../../components/payment/list/PaymentListAdministration.vue'
			),
		props: {
			default: true,
			type: 'payment-pcr'
		},
		meta: {
			label: 'router.label.paymentsPCR',
			subLabel: 'router.subLabel.administration',
			can: 'payments_administration_pcr',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/pcr/validation',
		name: 'paymentListPcrValidation',
		component: () => import(
			/* webpackChunkName: "payment_list_validation" */
			'../../components/payment/list/PaymentListValidation.vue'
		),
		props: {
			default: true,
			type: 'payment-pcr'
		},
		meta: {
			label: 'router.label.paymentsPCR',
			subLabel: 'router.subLabel.validation',
			can: 'payments_validation_pcr',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/pcr/liquidation',
		name: 'paymentListPcrLiquidation',
		component: () => import(
			/* webpackChunkName: "payment_list_liquidation" */
			'../../components/payment/list/PaymentListLiquidation.vue'
		),
		props: {
			default: true,
			type: 'payment-pcr'
		},
		meta: {
			label: 'router.label.paymentsPCR',
			subLabel: 'router.subLabel.liquidation',
			can: 'payments_liquidation_pcr',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/pcr/supervision',
		name: 'paymentListPcrSupervision',
		component: () => import(
			/* webpackChunkName: "payment_list_supervision" */
			'../../components/payment/list/PaymentListSupervision.vue'
		),
		props: {
			default: true,
			type: 'payment-pcr'
		},
		meta: {
			label: 'router.label.paymentsPCR',
			subLabel: 'router.subLabel.supervision',
			can: 'payments_supervision_pcr',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/dgos',
		name: 'paymentsDgos',
		component: () => import(
			/* webpackChunkName: "paymentList" */
			'../../views/Payments.vue'
		),
		props: {
			default: true,
			type: 'payment-dgos'
		}
	},
	{
		path: '/paiements/dgos/administration',
		name: 'paymentListDgosAdministration',
		component: () => import(
			/* webpackChunkName: "payment_list_administration_dgos" */
			'../../components/payment/list/PaymentListAdministration.vue'
		),
		props: {
			default: true,
			type: 'payment-dgos'
		},
		meta: {
			label: 'router.label.paymentsDGOS',
			subLabel: 'router.subLabel.administration',
			can: 'payments_administration_dgos',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/dgos/supervision',
		name: 'paymentListDgosSupervision',
		component: () => import(
			/* webpackChunkName: "payment_list_supervision_dgos" */
			'../../components/payment/list/PaymentListSupervision.vue'
		),
		props: {
			default: true,
			type: 'payment-dgos'
		},
		meta: {
			label: 'router.label.paymentsDGOS',
			subLabel: 'router.subLabel.supervision',
			can: 'payments_supervision_dgos',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/paiements/dgos/validation-dgos',
		name: 'paymentListDgosValidation',
		component: () => import(
			/* webpackChunkName: "payment_list_validation-dgos" */
			'../../components/payment/list/PaymentListValidationDGOS.vue'
		),
		props: {
			default: true,
			type: 'payment-dgos'
		},
		meta: {
			label: 'router.label.paymentsDGOS',
			subLabel: 'router.subLabel.validation_dgos',
			can: 'payments_validation_dgos',
			hiddenOnProjectRoute: true
		}
	}
] as RouteConfig[];

export default paymentRoute;
